import * as React from "react";
type Props = {
  className?: string,
};
function SvgBuyMoreSaveMore({ className }: Props) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-BuyMoreSaveMore"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7045 36H18.6576C18.9466 33.7801 20.7855 32.0684 23.0114 32.0684C25.2372 32.0684 27.0762 33.7801 27.3651 36H31.3182C31.0147 31.5294 27.4117 28 23.0114 28C18.611 28 15.008 31.5294 14.7045 36Z"
        fill="currentColor"
      />
      <path
        d="M4.22375 24H42.7762L38.5562 43H8.4438L4.22375 24Z"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M34.25 17L32.2796 10.1686C31.9092 8.8843 30.7338 8 29.3971 8H17.6029C16.2662 8 15.0908 8.8843 14.7204 10.1686L12.75 17"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M39.1364 17L36.4077 7.60539C35.7873 5.46936 33.8304 4 31.6061 4H15.3938C13.1695 4 11.2127 5.46937 10.5923 7.6054L7.86365 17"
        stroke="currentColor"
        strokeWidth={2}
      />
      <mask
        id="mask0_9916_27473"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={2}
        y={16}
        width={43}
        height={9}
      >
        <path
          d="M44 16H3C2.44772 16 2 16.4477 2 17V24C2 24.5523 2.44772 25 3 25H44C44.5523 25 45 24.5523 45 24V17C45 16.4477 44.5523 16 44 16Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_9916_27473)">
        <path
          d="M44 16H3C2.44772 16 2 16.4477 2 17V24C2 24.5523 2.44772 25 3 25H44C44.5523 25 45 24.5523 45 24V17C45 16.4477 44.5523 16 44 16Z"
          stroke="currentColor"
          strokeWidth={4}
        />
      </g>
    </svg>
  );
}
export default SvgBuyMoreSaveMore;
